module.exports = __webpack_public_path__ + "static/media/bespoke.1484285e.svg";